import angular from 'angular';

import ForgotPasswordRequestModule from './forgot-password-request';
import ForgotPasswordConfirmModule from './forgot-password-confirm';
import ForgotPasswordResetModule from './forgot-password-reset';
import ForgotPasswordTokenExpiredModule from './forgot-password-token-expired';

export default angular
    .module('application.scene.identity.scene.forgot-password.scene', [
        ForgotPasswordRequestModule.name,
        ForgotPasswordConfirmModule.name,
        ForgotPasswordResetModule.name,
        ForgotPasswordTokenExpiredModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/forgot-password/scene/index.js